function useCountries() {
  function filterCountries(input: string) {
    return countries.filter((country) => {
      return (
        country.Navn.toLowerCase().includes(input.toLowerCase()) ||
        country.Landekode.toLowerCase().includes(input.toLowerCase())
      );
    });
  }
  function getCountryByCountryCode(countryCode: string) {
    return countries.find((country) => country.Landekode === countryCode);
  }
  function getCountryByCountryName(countryName: string) {
    return countries.find((country) => country.Navn === countryName);
  }

  return {
    countries,
    filterCountries,
    getCountryByCountryCode,
    getCountryByCountryName,
  };
}
export default useCountries;

const countries = [
  {
    Id: "B5B4ED1B-E602-486C-8E29-19D644D47706",
    Landekode: "AF",
    Navn: "Afghanistan",
  },
  {
    Id: "46D50213-D169-4324-9C5C-0FA8ED7F7BFC",
    Landekode: "AL",
    Navn: "Albanien",
  },
  {
    Id: "53D0E569-C481-4D99-813A-E35A95EE6FCD",
    Landekode: "DZ",
    Navn: "Algeriet",
  },
  {
    Id: "2DFDE2CA-709F-4A2D-A1E8-C0F36785F4EC",
    Landekode: "AS",
    Navn: "Amerikansk Samoa",
  },
  {
    Id: "C0D2F1BA-AC0D-4BDC-BC04-7C5C0EE150F8",
    Landekode: "VI",
    Navn: "Amerikanske Jomfruøer",
  },
  {
    Id: "B5F4B83A-85AA-4027-A21E-94904C652735",
    Landekode: "AD",
    Navn: "Andorra",
  },
  {
    Id: "FF80E6EC-8FA4-4FD3-8439-E9B3CF048799",
    Landekode: "AO",
    Navn: "Angola",
  },
  {
    Id: "8B470E32-B191-4A88-B898-85AD64DF46E1",
    Landekode: "AI",
    Navn: "Anguilla",
  },
  {
    Id: "18FFF97B-E236-4647-A1B3-B3BD0EC939ED",
    Landekode: "AQ",
    Navn: "Antarktis",
  },
  {
    Id: "782B2885-CEEF-48F7-B295-087EFB261CA8",
    Landekode: "AG",
    Navn: "Antigua og Barbuda",
  },
  {
    Id: "872D00AB-238A-4C57-861A-4135118454BA",
    Landekode: "AR",
    Navn: "Argentina",
  },
  {
    Id: "3FCFC14A-D2DE-4EDA-A1C2-761FD7FCEC2C",
    Landekode: "AM",
    Navn: "Armenien",
  },
  {
    Id: "7A6832A2-8982-4B38-B5F2-0250B4DF1085",
    Landekode: "AW",
    Navn: "Aruba",
  },
  {
    Id: "A3E5770D-7A59-4201-A780-19917D4F6FFC",
    Landekode: "AZ",
    Navn: "Aserbajdsjan",
  },
  {
    Id: "0A55CAF2-F0C1-4B66-8C78-E07342492844",
    Landekode: "AU",
    Navn: "Australien",
  },
  {
    Id: "9F6D5E15-C832-4AC5-BC8F-E8CF744C3742",
    Landekode: "BS",
    Navn: "Bahamas",
  },
  {
    Id: "4167AAB4-B564-4931-BE4E-436F27999ABD",
    Landekode: "BH",
    Navn: "Bahrain",
  },
  {
    Id: "B01BA1B9-A93E-43B2-9367-77AF5AF8B66A",
    Landekode: "BD",
    Navn: "Bangladesh",
  },
  {
    Id: "1E88CD1C-613B-4875-ABE0-541DE22770F4",
    Landekode: "BB",
    Navn: "Barbados",
  },
  {
    Id: "6C48C00A-1B58-4A12-871D-C763C277FC8E",
    Landekode: "BY",
    Navn: "Belarus",
  },
  {
    Id: "913F9637-F03D-4995-8C92-66A832DC19FE",
    Landekode: "BE",
    Navn: "Belgien",
  },
  {
    Id: "9FEA0011-DA6E-4929-98DE-C0D698790AC2",
    Landekode: "BZ",
    Navn: "Belize",
  },
  {
    Id: "B06247BB-EA0D-4A69-8F5C-34DB286056EF",
    Landekode: "BJ",
    Navn: "Benin",
  },
  {
    Id: "6ED045AB-AC37-429E-8352-83CB6D0BA534",
    Landekode: "BM",
    Navn: "Bermuda",
  },
  {
    Id: "E19B5D29-A37B-493F-AC69-704DA5F75373",
    Landekode: "BT",
    Navn: "Bhutan",
  },
  {
    Id: "11260CE6-13C5-4AA4-ABBB-4CCAD1E07F06",
    Landekode: "BO",
    Navn: "Bolivia",
  },
  {
    Id: "DFD50270-DB2E-4A25-8144-F8CFBC8B9115",
    Landekode: "BQ",
    Navn: "Bonaire, Skt. Eustatius og Saba",
  },
  {
    Id: "E1F0A1B7-7957-41E5-944F-E9AFBD4CBB45",
    Landekode: "BA",
    Navn: "Bosnien-Hercegovina",
  },
  {
    Id: "C2671698-1761-48F6-8297-B5C84CC9C68B",
    Landekode: "BW",
    Navn: "Botswana",
  },
  {
    Id: "C42AF7DD-3055-4F0D-9457-8998F8196F43",
    Landekode: "BV",
    Navn: "Bouvetøen",
  },
  {
    Id: "28B9FFA2-310E-4185-8CA2-75568FDB3774",
    Landekode: "BR",
    Navn: "Brasilien",
  },
  {
    Id: "14C60220-DCBF-4C9D-B1EC-E6CC8368E722",
    Landekode: "IO",
    Navn: "Britisk territorium i det Indiske Ocean",
  },
  {
    Id: "A89F149D-2837-4BC6-B036-FA8CFC64C5C2",
    Landekode: "VG",
    Navn: "Britiske Jomfruøer",
  },
  {
    Id: "A73BD307-8EB0-46A9-BF64-7429C2DE4BAA",
    Landekode: "BN",
    Navn: "Brunei",
  },
  {
    Id: "754B191F-8079-4284-9949-6B98FB8AF39C",
    Landekode: "BG",
    Navn: "Bulgarien",
  },
  {
    Id: "09A5CBC0-B53C-4DBE-A90B-B87843C5E11A",
    Landekode: "BF",
    Navn: "Burkina Faso",
  },
  {
    Id: "19EA6B88-2C93-4A23-B998-2C7D5C101EA5",
    Landekode: "BI",
    Navn: "Burundi",
  },
  {
    Id: "FFB0C6D2-269A-4AB2-A7AC-87A5B1DCC208",
    Landekode: "KH",
    Navn: "Cambodja",
  },
  {
    Id: "4E4775EF-462C-4110-8DAF-147FB02A1A90",
    Landekode: "CM",
    Navn: "Cameroun",
  },
  {
    Id: "3CFE4BFD-67F7-468D-A925-E9DEA68B3B61",
    Landekode: "CA",
    Navn: "Canada",
  },
  {
    Id: "BC52B99D-FA97-4283-980F-613CB5846FE1",
    Landekode: "KY",
    Navn: "Caymanøerne",
  },
  {
    Id: "86159CFD-3F88-434D-92B3-D3420CDD3FE4",
    Landekode: "CF",
    Navn: "Centralafrikanske Republik",
  },
  {
    Id: "25F1DDC3-9AA2-4A5A-B2E5-DD3BA75B9422",
    Landekode: "CL",
    Navn: "Chile",
  },
  {
    Id: "9BFB1142-9413-4890-952D-67D4237E171A",
    Landekode: "CC",
    Navn: "Cocosøerne",
  },
  {
    Id: "08B033D9-A90A-4CEC-94DE-B3A5FB584EA9",
    Landekode: "CO",
    Navn: "Colombia",
  },
  {
    Id: "4FA9E13F-A0BD-4495-B5E4-FD130CB12478",
    Landekode: "KM",
    Navn: "Comorerne",
  },
  {
    Id: "BEBAC50B-F69F-4EE8-BCDD-8DC2EC2F3BB0",
    Landekode: "CD",
    Navn: "Congo, Demokratiske Republik",
  },
  {
    Id: "58BC88AE-876A-4D1B-8E5D-5AE3C3EEF4BA",
    Landekode: "CG",
    Navn: "Congo, Republikken",
  },
  {
    Id: "E53F389A-D0DB-4D12-8459-700A6A1D385D",
    Landekode: "CK",
    Navn: "Cookøerne",
  },
  {
    Id: "94401851-F412-4B30-9FD1-7A2CF0CFC4E4",
    Landekode: "CR",
    Navn: "Costa Rica",
  },
  { Id: "1EDE8C71-459A-44A7-A824-60DFC9F7E46B", Landekode: "CU", Navn: "Cuba" },
  {
    Id: "C81F5EAB-039E-4F0C-82F7-5867247293F9",
    Landekode: "CW",
    Navn: "Curacao",
  },
  {
    Id: "98452FB5-4E74-48FA-8513-5CF4D6BDBEB8",
    Landekode: "CY",
    Navn: "Cypern",
  },
  {
    Id: "32578C11-A35F-46EF-8571-259952322D8A",
    Landekode: "DK",
    Navn: "Danmark",
  },
  {
    Id: "CC9DC55A-4886-4554-8998-E98F8E844971",
    Landekode: "DJ",
    Navn: "Djibouti",
  },
  {
    Id: "6E5D6D6A-6DAB-4C37-89E3-057ED88AE04C",
    Landekode: "DM",
    Navn: "Dominica",
  },
  {
    Id: "15A0E947-67BA-4F9C-954D-79C17022239A",
    Landekode: "DO",
    Navn: "Dominikanske Republik",
  },
  {
    Id: "B02DC8D9-1E4E-430B-8618-DAD3E76C17CD",
    Landekode: "EC",
    Navn: "Ecuador",
  },
  {
    Id: "005537C8-71BC-4342-82E5-879FDEADA8D6",
    Landekode: "EG",
    Navn: "Egypten",
  },
  {
    Id: "EB5968FB-9BDB-4224-933A-273AA90F7F19",
    Landekode: "SV",
    Navn: "El Salvador",
  },
  {
    Id: "4BD8634F-6D03-4E50-8150-49676383EDC5",
    Landekode: "CI",
    Navn: "Elfenbenskysten",
  },
  {
    Id: "A60F10C3-CAE5-408A-A370-9F62D6D34079",
    Landekode: "ER",
    Navn: "Eritrea",
  },
  {
    Id: "A2FB0A4B-463C-4F91-9E49-3900E53DF8C9",
    Landekode: "EE",
    Navn: "Estland",
  },
  {
    Id: "B70269F7-1C07-48F6-8B34-2E2D6B6CE8F4",
    Landekode: "SZ",
    Navn: "Eswatini",
  },
  {
    Id: "65B29AD3-6367-46DB-BCAA-7CDD93A0BA85",
    Landekode: "ET",
    Navn: "Etiopien",
  },
  {
    Id: "C165B375-AD65-4673-B8FD-0A5885C4C1F1",
    Landekode: "FK",
    Navn: "Falklandsøerne",
  },
  { Id: "70224175-6EAE-4D13-B348-1A1C7393C1A4", Landekode: "FJ", Navn: "Fiji" },
  {
    Id: "C77787D0-1F6F-4021-A9B7-1934916E9058",
    Landekode: "PH",
    Navn: "Filippinerne",
  },
  {
    Id: "0657B94A-2E04-4A55-8820-5D10D181FDE9",
    Landekode: "FI",
    Navn: "Finland",
  },
  {
    Id: "95C9BB6F-2CBD-4932-A13B-80D84BE45939",
    Landekode: "AE",
    Navn: "Forenede Arabiske Emirater",
  },
  {
    Id: "D97DC66B-E034-47D2-A8B6-C51BAE7C2C71",
    Landekode: "FR",
    Navn: "Frankrig",
  },
  {
    Id: "2E18B644-0156-4728-B7AE-F94D1CA466D5",
    Landekode: "GF",
    Navn: "Fransk Guyana",
  },
  {
    Id: "40099FFA-1213-4E69-93FD-32C3404057C5",
    Landekode: "PF",
    Navn: "Fransk Polynesien",
  },
  {
    Id: "5E0117B9-CD32-4D57-ADAA-4865946A6025",
    Landekode: "TF",
    Navn: "Franske Sydlige og Antarktiske Territorier",
  },
  {
    Id: "95E29C94-EEDD-46C3-A715-2161B9882267",
    Landekode: "FO",
    Navn: "Færøerne",
  },
  {
    Id: "027BD873-0AC2-4839-B53D-26D289A04388",
    Landekode: "GA",
    Navn: "Gabon",
  },
  {
    Id: "B4B26E6D-EC38-4FD6-99E3-8B163A8B7FC7",
    Landekode: "GM",
    Navn: "Gambia",
  },
  {
    Id: "4D014B69-CE46-4463-9E1D-C28DB9FCDC7C",
    Landekode: "GE",
    Navn: "Georgien",
  },
  {
    Id: "5DE4861E-8603-410E-8786-99B75CD6948D",
    Landekode: "GH",
    Navn: "Ghana",
  },
  {
    Id: "A786C922-72B7-4A50-B89E-28C670917443",
    Landekode: "GI",
    Navn: "Gibraltar",
  },
  {
    Id: "79C22E7D-CCEA-4110-8A5C-E1DA4A174081",
    Landekode: "GD",
    Navn: "Grenada",
  },
  {
    Id: "DAC14E4A-B1E6-4303-A995-A65EB7E77D96",
    Landekode: "GR",
    Navn: "Grækenland",
  },
  {
    Id: "F73DBAF8-6C73-450C-B205-E3A07961DD23",
    Landekode: "GL",
    Navn: "Grønland",
  },
  {
    Id: "330BFA0C-4845-47D6-9F60-04415232743D",
    Landekode: "GP",
    Navn: "Guadeloupe",
  },
  { Id: "B4535135-3BC7-49DC-8A2B-448AB0D974ED", Landekode: "GU", Navn: "Guam" },
  {
    Id: "477E1816-F59A-47A2-AC96-6CA180E43920",
    Landekode: "GT",
    Navn: "Guatemala",
  },
  {
    Id: "19D3F9B6-1D6A-4A8E-A949-87F27CD4D515",
    Landekode: "GG",
    Navn: "Guernsey",
  },
  {
    Id: "5AB0882E-B43C-47D3-875E-0C720D36DD96",
    Landekode: "GN",
    Navn: "Guinea",
  },
  {
    Id: "59DC08EC-6237-471F-96D8-54F5821B1A4D",
    Landekode: "GW",
    Navn: "Guinea-Bissau",
  },
  {
    Id: "B445A4EA-F1FD-4B88-9882-50F42437CAB4",
    Landekode: "GY",
    Navn: "Guyana",
  },
  {
    Id: "06A0458B-072E-4EA9-BDD7-19ABC132AEC6",
    Landekode: "HT",
    Navn: "Haiti",
  },
  {
    Id: "41478806-5C6F-4946-AD14-A45CA8C59142",
    Landekode: "HM",
    Navn: "Heard- og McDonaldøerne",
  },
  {
    Id: "A22BB2F8-C3A9-47A9-A9E7-ACF0D99ADEA2",
    Landekode: "HN",
    Navn: "Honduras",
  },
  {
    Id: "412B749D-BBF5-4B77-9505-CDB74BD62CE8",
    Landekode: "HK",
    Navn: "Hong Kong",
  },
  {
    Id: "04FCABE5-356E-47D7-99EF-31AE40A8C096",
    Landekode: "IN",
    Navn: "Indien",
  },
  {
    Id: "CA15C32E-0F07-42BF-BFAC-F415CBB043DF",
    Landekode: "ID",
    Navn: "Indonesien",
  },
  { Id: "A78BCFF7-9CBF-49DF-AF10-224CEEC163DA", Landekode: "IQ", Navn: "Irak" },
  { Id: "70CE9EEA-0BA2-4510-8F58-8D7FB2C86555", Landekode: "IR", Navn: "Iran" },
  {
    Id: "6ABD2187-172C-45D1-9AB3-86A8AB6F694D",
    Landekode: "IE",
    Navn: "Irland",
  },
  {
    Id: "4F554C13-8128-4F27-B35B-4CF15BED307C",
    Landekode: "IS",
    Navn: "Island",
  },
  {
    Id: "EF107B16-A783-482F-A888-B7930D4C6F55",
    Landekode: "IM",
    Navn: "Isle of Man",
  },
  {
    Id: "F27E3F0A-F7B6-42C7-AAA1-FBC927261553",
    Landekode: "IL",
    Navn: "Israel",
  },
  {
    Id: "99BC1311-F2C5-444C-8149-DAB5AD0BCF5D",
    Landekode: "IT",
    Navn: "Italien",
  },
  {
    Id: "DD195330-D4F5-48CB-92CF-A2769CB9C1DE",
    Landekode: "JM",
    Navn: "Jamaica",
  },
  {
    Id: "542FB800-4617-484F-9B3C-CA26E6BE79B9",
    Landekode: "JP",
    Navn: "Japan",
  },
  {
    Id: "D5D747B1-7B23-4ED9-ADCB-762C5DB7B789",
    Landekode: "JE",
    Navn: "Jersey",
  },
  {
    Id: "AE34DFC3-F9DF-41CB-9EC3-19A8282DE508",
    Landekode: "JO",
    Navn: "Jordan",
  },
  {
    Id: "1D8423A7-7A9B-4BE8-97EF-C0F35A18C375",
    Landekode: "CX",
    Navn: "Juleøen",
  },
  {
    Id: "A2E82293-3377-4A2B-8D94-FD36BC4AD5C4",
    Landekode: "CV",
    Navn: "Kap Verde",
  },
  {
    Id: "7D0A993E-5846-4D2F-81D4-D05CCC13B34B",
    Landekode: "KZ",
    Navn: "Kasakhstan",
  },
  {
    Id: "A9BEDAA9-61DA-4E4E-97C7-BA1AF3A985D0",
    Landekode: "KE",
    Navn: "Kenya",
  },
  { Id: "57F46473-D54F-494E-A5DC-05490465BEF4", Landekode: "CN", Navn: "Kina" },
  {
    Id: "2428D7B4-0D67-41B5-B5DB-4EBEF04CF289",
    Landekode: "KG",
    Navn: "Kirgisistan",
  },
  {
    Id: "05A5B9F6-9B3B-4662-96D4-0AC8651E8893",
    Landekode: "KI",
    Navn: "Kiribati",
  },
  {
    Id: "4D897C6A-DA9C-4068-9B29-18EF15C44A8A",
    Landekode: "HR",
    Navn: "Kroatien",
  },
  {
    Id: "46069CDE-B342-4BA3-B797-56642AAFD5C3",
    Landekode: "KW",
    Navn: "Kuwait",
  },
  { Id: "ECCB42D3-28F9-4C92-B8EE-C70CC074DB3B", Landekode: "LA", Navn: "Laos" },
  {
    Id: "B28804A6-E0C4-4214-99DC-3577BEF1D144",
    Landekode: "LS",
    Navn: "Lesotho",
  },
  {
    Id: "7A4ACEAE-8CE6-437E-A524-8A949E20E9AD",
    Landekode: "LV",
    Navn: "Letland",
  },
  {
    Id: "E4248721-373D-4944-9B7E-BF83E003DDB8",
    Landekode: "LB",
    Navn: "Libanon",
  },
  {
    Id: "EF069A4A-4323-474F-BD38-632D6D1B6B2B",
    Landekode: "LR",
    Navn: "Liberia",
  },
  {
    Id: "3B476918-BDB8-44D6-85FF-CFF1A3265D07",
    Landekode: "LY",
    Navn: "Libyen",
  },
  {
    Id: "20E99E6A-175A-4BB2-A332-18A9DAB4D82C",
    Landekode: "LI",
    Navn: "Liechtenstein",
  },
  {
    Id: "AEBFCF7F-941A-4B2C-BD1F-DD8CE2044834",
    Landekode: "LT",
    Navn: "Litauen",
  },
  {
    Id: "0A20630D-6C34-4072-9E8B-470807768443",
    Landekode: "LU",
    Navn: "Luxembourg",
  },
  {
    Id: "5B043DA7-02B5-4A74-B304-35632CEBB84D",
    Landekode: "MO",
    Navn: "Macao",
  },
  {
    Id: "46F68D12-8A8A-47BC-9279-81987A630307",
    Landekode: "MG",
    Navn: "Madagaskar",
  },
  {
    Id: "69BCDAAD-0A55-4C7A-9DA9-5B0906D3E4F7",
    Landekode: "MW",
    Navn: "Malawi",
  },
  {
    Id: "A01CEAA8-060F-4567-AFBB-FADC6F44F3FC",
    Landekode: "MY",
    Navn: "Malaysia",
  },
  {
    Id: "50C501A6-970B-472C-95CD-99F609E1653B",
    Landekode: "MV",
    Navn: "Maldiverne",
  },
  { Id: "224B65C9-695A-4A74-904F-699019B071C2", Landekode: "ML", Navn: "Mali" },
  {
    Id: "F2315015-E5FC-4EC9-B75A-58206E977816",
    Landekode: "MT",
    Navn: "Malta",
  },
  {
    Id: "09688950-79EB-4543-B02D-199C130F56DF",
    Landekode: "MA",
    Navn: "Marokko",
  },
  {
    Id: "177C39D3-599F-4B0B-967B-F27423B81D35",
    Landekode: "MH",
    Navn: "Marshalløerne",
  },
  {
    Id: "425E7646-4AFF-40E0-8585-0CF50C3218E8",
    Landekode: "MQ",
    Navn: "Martinique",
  },
  {
    Id: "4928D077-D453-4F73-9CD6-11FE28C16E5A",
    Landekode: "MR",
    Navn: "Mauretanien",
  },
  {
    Id: "13220D6E-D3FF-422D-91DA-D2BCD1AEA1A7",
    Landekode: "MU",
    Navn: "Mauritius",
  },
  {
    Id: "B1F39E0B-A5ED-4A6F-8506-9F1B3D10F5DC",
    Landekode: "YT",
    Navn: "Mayotte",
  },
  {
    Id: "C59B5D2B-7B5C-4D83-AB07-28479D899810",
    Landekode: "MX",
    Navn: "Mexico",
  },
  {
    Id: "8C7B0DF6-4CD7-4801-9CA9-687767DA9E0C",
    Landekode: "FM",
    Navn: "Mikronesien",
  },
  {
    Id: "E0241E53-5595-45E6-878A-909A98928F46",
    Landekode: "MD",
    Navn: "Moldova",
  },
  {
    Id: "3B5A3E2F-C3A1-4A89-8919-1138E06D51E6",
    Landekode: "MC",
    Navn: "Monaco",
  },
  {
    Id: "E7FEAD4B-6A64-42D4-A31E-47D6BF0C3F63",
    Landekode: "MN",
    Navn: "Mongoliet",
  },
  {
    Id: "CCED4DC9-9812-4061-A719-1EBA6D7976DE",
    Landekode: "ME",
    Navn: "Montenegro",
  },
  {
    Id: "37067185-A9E3-4A08-8B70-41C9708293A1",
    Landekode: "MS",
    Navn: "Montserrat",
  },
  {
    Id: "75EBD723-019E-4412-BA55-38857F801167",
    Landekode: "MZ",
    Navn: "Mozambique",
  },
  {
    Id: "332EF346-C073-4DAF-AC77-729134C1B06F",
    Landekode: "MM",
    Navn: "Myanmar",
  },
  {
    Id: "30B7E0B3-A575-420E-A671-F7352FB855DB",
    Landekode: "NA",
    Navn: "Namibia",
  },
  {
    Id: "2E251793-125C-4719-9A87-480975FBA0A2",
    Landekode: "NR",
    Navn: "Nauru",
  },
  {
    Id: "E1BFE8C3-17BF-4634-9FAA-F5114015B7E2",
    Landekode: "NL",
    Navn: "Nederlandene",
  },
  {
    Id: "5AF2A17D-1F67-427F-AB9F-CC8C5B5DC704",
    Landekode: "NP",
    Navn: "Nepal",
  },
  {
    Id: "800C686F-5E71-44EF-A603-21EEFFC62454",
    Landekode: "NZ",
    Navn: "New Zealand",
  },
  {
    Id: "C7D71734-766C-44F2-BCFD-FDC5EE768199",
    Landekode: "NI",
    Navn: "Nicaragua",
  },
  {
    Id: "63DEACDF-66A4-4278-B5D0-2AC996855F53",
    Landekode: "NE",
    Navn: "Niger",
  },
  {
    Id: "D35C04C8-060A-462C-8BDD-DF9246134FDB",
    Landekode: "NG",
    Navn: "Nigeria",
  },
  { Id: "DF9ED70B-89BD-4759-BF25-D084E137ED29", Landekode: "NU", Navn: "Niue" },
  {
    Id: "7484254A-77B0-441B-90CB-5C473AE3C87C",
    Landekode: "KP",
    Navn: "Nordkorea",
  },
  {
    Id: "92C0A26A-9EE5-4E56-9155-DEBC613398FF",
    Landekode: "MK",
    Navn: "Nordmakedonien",
  },
  {
    Id: "967C7775-C865-428F-9FC8-0EBB2A742E87",
    Landekode: "MP",
    Navn: "Nordmarianerne",
  },
  {
    Id: "8B6DA27E-AEE2-45EA-89EB-9F66E630E130",
    Landekode: "NF",
    Navn: "Norfolkøen",
  },
  {
    Id: "9E0D21FA-81DC-4FDC-8FC6-B86391F1A813",
    Landekode: "NO",
    Navn: "Norge",
  },
  {
    Id: "0F844E87-3852-42E9-81A3-35A3AD19E3BC",
    Landekode: "NC",
    Navn: "Ny Kaledonien",
  },
  { Id: "B8890BBF-5A82-4ACD-9840-BA414A9B292D", Landekode: "OM", Navn: "Oman" },
  { Id: "9B515D43-AD72-4CBE-90EF-A925FC624072", Landekode: "ON", Navn: "Oman" },
  {
    Id: "38D5A2F1-36DA-4A15-A928-3865F6B319EB",
    Landekode: "PK",
    Navn: "Pakistan",
  },
  {
    Id: "E950727A-EE24-49CC-A9C3-830B5C3DE8BE",
    Landekode: "PW",
    Navn: "Palau",
  },
  {
    Id: "5A7A6EFA-6743-4609-981D-8D496FE48BED",
    Landekode: "PS",
    Navn: "Palæstina",
  },
  {
    Id: "FC401A45-A9D5-4750-B44C-B200EC65A2AF",
    Landekode: "PA",
    Navn: "Panama",
  },
  {
    Id: "709A27D1-41F1-4166-BED5-DA7664E5B2B7",
    Landekode: "PG",
    Navn: "Papua Ny Guinea",
  },
  {
    Id: "377D6AA3-6E7C-42D2-86CC-1CFD027F9222",
    Landekode: "PY",
    Navn: "Paraguay",
  },
  { Id: "566BCC6C-C33E-49A1-B331-A52E17ED5C35", Landekode: "PE", Navn: "Peru" },
  {
    Id: "5EBC5099-E6AC-4E04-8047-416A7C1E4EBD",
    Landekode: "PN",
    Navn: "Pitcairn",
  },
  {
    Id: "BCABA5C8-442E-4393-9416-C63991D7BCDC",
    Landekode: "PL",
    Navn: "Polen",
  },
  {
    Id: "38E57824-5815-4BEE-A6B4-1FB2255FDAC1",
    Landekode: "PT",
    Navn: "Portugal",
  },
  {
    Id: "9FD08E9C-FA85-4985-A96A-DDD9F5197514",
    Landekode: "PR",
    Navn: "Puerto Rico",
  },
  {
    Id: "D73F84DF-3A18-41EF-B602-20B2FFA3F4A0",
    Landekode: "QA",
    Navn: "Qatar",
  },
  {
    Id: "53FBF7B7-B96E-426A-AA6F-76BCA36C7C77",
    Landekode: "RE",
    Navn: "Reunion",
  },
  {
    Id: "92905EF2-62B0-4FAA-83B8-9342852480F4",
    Landekode: "RO",
    Navn: "Rumænien",
  },
  {
    Id: "1661EF0F-DE6C-408C-B798-3E3A9A490397",
    Landekode: "RU",
    Navn: "Rusland",
  },
  {
    Id: "8FFB25F2-32B0-497E-A381-91FD5F5349DA",
    Landekode: "RW",
    Navn: "Rwanda",
  },
  {
    Id: "2A91CD7F-3CE9-4B69-846F-C85157D077D2",
    Landekode: "SB",
    Navn: "Salomonøerne",
  },
  {
    Id: "0130DDEF-2116-4BBD-9946-22F336781F14",
    Landekode: "WS",
    Navn: "Samoa",
  },
  {
    Id: "1FA13C9E-C5AA-4446-8F8D-D50E848BA89C",
    Landekode: "SM",
    Navn: "San Marino",
  },
  {
    Id: "024B4FC3-B0BA-4E4B-82CF-76FF78D4AA8A",
    Landekode: "ST",
    Navn: "Sao Tome og Principe",
  },
  {
    Id: "EDEF799B-45A9-4279-8564-38BE88DA3A56",
    Landekode: "SA",
    Navn: "Saudi-Arabien",
  },
  {
    Id: "1C4BEBA3-F5DE-48AD-9496-1577DA52FC96",
    Landekode: "CH",
    Navn: "Schweiz",
  },
  {
    Id: "A7E92DF1-B651-447C-AED4-E835222C2EEF",
    Landekode: "SN",
    Navn: "Senegal",
  },
  {
    Id: "EDCD0D5C-D49B-49C2-A605-B81F853EE545",
    Landekode: "RS",
    Navn: "Serbien",
  },
  {
    Id: "AA454999-9DAD-4F57-8E3F-08D98DD9C32A",
    Landekode: "SC",
    Navn: "Seychellerne",
  },
  {
    Id: "7C0A7A2D-83BD-421D-8557-95A3B4A98841",
    Landekode: "SL",
    Navn: "Sierra Leone",
  },
  {
    Id: "003893AB-EE98-41C3-99E8-519C588F3AEA",
    Landekode: "SG",
    Navn: "Singapore",
  },
  {
    Id: "68CBB6E5-DEAE-42F9-BB82-4B04E3B414DA",
    Landekode: "BL",
    Navn: "Skt. Barthelemy",
  },
  {
    Id: "F9BD42C4-56B4-47A0-BB6B-8F44D6E298B8",
    Landekode: "SH",
    Navn: "Skt. Helena",
  },
  {
    Id: "7915EDBC-C753-47E7-BF35-AFC3AB4DA544",
    Landekode: "KN",
    Navn: "Skt. Kitts og Nevis",
  },
  {
    Id: "F1EF6665-129D-431C-A1CB-5892AAEF1FCE",
    Landekode: "LC",
    Navn: "Skt. Lucia",
  },
  {
    Id: "B096E505-6C77-4C98-800C-212291C78782",
    Landekode: "SX",
    Navn: "Skt. Martin (NL)",
  },
  {
    Id: "A710A99D-B314-46BC-839E-60929057345D",
    Landekode: "PM",
    Navn: "Skt. Pierre og Miquelon",
  },
  {
    Id: "6ADB6617-DB8F-46E7-BD5E-2BC38EB75259",
    Landekode: "VC",
    Navn: "Skt. Vincent og Grenadinerne",
  },
  {
    Id: "1AA6B412-C9CF-4CC0-9141-441FCA45FD3B",
    Landekode: "SK",
    Navn: "Slovakiet",
  },
  {
    Id: "1F7921DF-468E-4D8F-A1FC-7314B193102F",
    Landekode: "SI",
    Navn: "Slovenien",
  },
  {
    Id: "637AB3F9-7E0B-480B-ADD9-B64FDE2CC4D1",
    Landekode: "SO",
    Navn: "Somalia",
  },
  {
    Id: "A3A68F5A-A2A5-434F-9DED-3AEFEF97C52C",
    Landekode: "ES",
    Navn: "Spanien",
  },
  {
    Id: "126F489B-43BE-425B-BB32-D2A014F19A3A",
    Landekode: "LK",
    Navn: "Sri Lanka",
  },
  {
    Id: "20B78ACD-3F2C-4852-B6D3-3C4E509AF8D0",
    Landekode: "MF",
    Navn: "St. Martin (FR)",
  },
  {
    Id: "3BA46E93-6CCF-4F41-B49D-C9749F064211",
    Landekode: "GB",
    Navn: "Storbritannien",
  },
  {
    Id: "0F9F4DA3-92D6-4C0D-B0C3-A929F7529158",
    Landekode: "SD",
    Navn: "Sudan",
  },
  {
    Id: "18064225-3FD3-43F3-B6CE-C120D7C8C143",
    Landekode: "SR",
    Navn: "Surinam",
  },
  {
    Id: "1E823E52-6C98-4C23-859D-869DC0BBAC25",
    Landekode: "SJ",
    Navn: "Svalbard og Jan Mayen",
  },
  {
    Id: "69454A49-4B9A-4DC8-AF87-AB1209E6372C",
    Landekode: "SE",
    Navn: "Sverige",
  },
  {
    Id: "6A045AEF-EE0D-45D3-BF33-1AE3F8075417",
    Landekode: "ZA",
    Navn: "Sydafrika",
  },
  {
    Id: "AC04A5FF-1900-4B33-9CA1-9FFE1F59E553",
    Landekode: "GS",
    Navn: "Sydgeorgien og Sydsandwichøerne",
  },
  {
    Id: "F9FFBFAB-ECD8-4F35-ABCC-61BAF47F9CD6",
    Landekode: "KR",
    Navn: "Sydkorea",
  },
  {
    Id: "8102F968-DE86-4080-A521-D3866670F286",
    Landekode: "SS",
    Navn: "Sydsudan",
  },
  {
    Id: "94B6DFF8-3953-4881-8A4E-A95C123EBC6F",
    Landekode: "SY",
    Navn: "Syrien",
  },
  {
    Id: "4C2C000D-DD30-444A-BC4E-C494B424464D",
    Landekode: "TJ",
    Navn: "Tadsjikistan",
  },
  {
    Id: "6B590ACA-0EB5-42F0-9FA5-131CCF52075E",
    Landekode: "TW",
    Navn: "Taiwan",
  },
  {
    Id: "A2DE8A34-B456-4AEF-97FC-33E9847B00E7",
    Landekode: "TZ",
    Navn: "Tanzania",
  },
  {
    Id: "EAB76840-8742-4174-8988-D0E57306BDA7",
    Landekode: "TD",
    Navn: "Tchad",
  },
  {
    Id: "CC9DBFE1-2ED4-4CFC-8506-17A625AD51B3",
    Landekode: "TH",
    Navn: "Thailand",
  },
  {
    Id: "40C2183F-A1CA-4F17-AE5E-09621BC5160F",
    Landekode: "CZ",
    Navn: "Tjekkiet",
  },
  { Id: "93E3D556-FC86-4068-81AF-EEE88A6D1CBE", Landekode: "TG", Navn: "Togo" },
  {
    Id: "D6EC0C49-03A6-4C1F-87C7-D618A80FDA70",
    Landekode: "TK",
    Navn: "Tokelau",
  },
  {
    Id: "25818B4C-B7D7-40D5-A986-C8F4BC226606",
    Landekode: "TO",
    Navn: "Tonga",
  },
  {
    Id: "4632318B-CE32-4455-B1D4-C178C15D5127",
    Landekode: "TT",
    Navn: "Trinidad og Tobago",
  },
  {
    Id: "B8BC92CA-1337-4CFC-BC33-EDA9250C5BF7",
    Landekode: "TN",
    Navn: "Tunesien",
  },
  {
    Id: "4B78EBCD-16DB-42A1-B604-98352920FD02",
    Landekode: "TM",
    Navn: "Turkmenistan",
  },
  {
    Id: "E7ABD6A6-EABB-460E-92F8-29257FD9CE54",
    Landekode: "TC",
    Navn: "Turks- og Caicosøerne",
  },
  {
    Id: "15606077-143F-4EA4-866E-E9C07D439493",
    Landekode: "TV",
    Navn: "Tuvalu",
  },
  {
    Id: "610AD0ED-D564-47CC-BE67-3BB3102632D2",
    Landekode: "TR",
    Navn: "Tyrkiet",
  },
  {
    Id: "099A6020-423A-47A9-AF11-9BC698AB22C4",
    Landekode: "DE",
    Navn: "Tyskland",
  },
  { Id: "09AE6241-4E1A-4FE1-9B4C-6038A8991812", Landekode: "US", Navn: "USA" },
  {
    Id: "80BECB80-B30A-46AD-B66F-EDC37E3CB3C6",
    Landekode: "UM",
    Navn: "USA's mindre øbesiddelser",
  },
  {
    Id: "74338EBF-9082-403A-BE03-A508F332F62A",
    Landekode: "UG",
    Navn: "Uganda",
  },
  {
    Id: "ACD24878-2765-452D-BC53-B340FD55E13C",
    Landekode: "UA",
    Navn: "Ukraine",
  },
  {
    Id: "D3E6BFAE-D3D7-4068-9288-1FB8D30BD7B7",
    Landekode: "HU",
    Navn: "Ungarn",
  },
  {
    Id: "48BA0D7A-DB98-4700-82D4-27B0B66BB404",
    Landekode: "UY",
    Navn: "Uruguay",
  },
  {
    Id: "5399AC6E-4980-4C99-BF0C-92FF56DBD8A6",
    Landekode: "UZ",
    Navn: "Usbekistan",
  },
  {
    Id: "27133ADA-59FF-42C9-9573-88EF91495B34",
    Landekode: "VU",
    Navn: "Vanuatu",
  },
  {
    Id: "68436BFC-75FA-4AE0-96E0-570771D09B30",
    Landekode: "VA",
    Navn: "Vatikanstaten",
  },
  {
    Id: "40AAB53D-1A41-4086-AC52-38CA8483ECAE",
    Landekode: "VE",
    Navn: "Venezuela",
  },
  {
    Id: "7BF35FC2-982E-487A-A228-3BA83E83A7AA",
    Landekode: "EH",
    Navn: "Vestsahara",
  },
  {
    Id: "4CC6CCF9-461D-41F6-B02C-D6E6C87CE395",
    Landekode: "VN",
    Navn: "Vietnam",
  },
  {
    Id: "1BA3A8AC-BDBC-4CDA-A16C-C5C983039E80",
    Landekode: "WF",
    Navn: "Wallis og Futuna",
  },
  {
    Id: "9970B9DD-AF9F-4C23-857A-A58D5286BF69",
    Landekode: "YE",
    Navn: "Yemen",
  },
  {
    Id: "4CEFE90A-0046-40E2-AA78-B26533E8A197",
    Landekode: "ZM",
    Navn: "Zambia",
  },
  {
    Id: "143FD6C4-AA7B-42CD-B968-0396FF38069B",
    Landekode: "ZW",
    Navn: "Zimbabwe",
  },
  {
    Id: "0CA8162A-7394-46E8-88DD-C5ADDEC403AD",
    Landekode: "AX",
    Navn: "Ålandsøerne",
  },
  {
    Id: "939104AF-BD04-45D5-A80F-7EF4467B0C20",
    Landekode: "GQ",
    Navn: "Ækvatorialguinea",
  },
  {
    Id: "75D72835-AB24-4E89-9A69-B013B976B278",
    Landekode: "AT",
    Navn: "Østrig",
  },
  {
    Id: "BBC5322B-2EF5-4708-A13E-699CAAA553EF",
    Landekode: "TL",
    Navn: "Østtimor",
  },
];
